import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogFooter,
  DialogTitle,
  DialogDescription,
} from '@ncoder/ui';
import { useMetadataEditorStore } from '@/stores/metadataEditorStore';

export function CloseConfirmDialog() {
  const pendingClose = useMetadataEditorStore((state) => state.pendingClose);
  const getPendingCloseTab = useMetadataEditorStore((state) => state.getPendingCloseTab);
  const confirmClose = useMetadataEditorStore((state) => state.confirmClose);

  const pendingTab = getPendingCloseTab();
  const isOpen = !!pendingClose && !!pendingTab;

  const handleCancel   = () => confirmClose(false);
  const handleDontSave = () => confirmClose(true);
  const handleSave     = () => confirmClose(true); // TODO: trigger save then close

  return (
    <Dialog open={isOpen} onOpenChange={(open: boolean) => !open && handleCancel()}>
      <DialogContent className="sm:max-w-[400px]">
        <DialogHeader>
          <DialogTitle className="text-sm font-semibold">Unsaved Changes</DialogTitle>
          <DialogDescription className="text-xs leading-relaxed">
            Close <span className="font-medium text-foreground">{pendingTab?.file.name}</span>?
            Your unsaved changes will be lost.
          </DialogDescription>
        </DialogHeader>
        <DialogFooter>
          <button
            type="button"
            onClick={handleCancel}
            className="px-3 py-1.5 text-xs rounded-lg border border-border text-muted-foreground hover:text-foreground hover:bg-muted transition-colors"
          >
            Cancel
          </button>
          <button
            type="button"
            onClick={handleDontSave}
            className="px-3 py-1.5 text-xs rounded-lg border border-border text-muted-foreground hover:text-foreground hover:bg-muted transition-colors"
          >
            Don't Save
          </button>
          <button
            type="button"
            onClick={handleSave}
            className="px-3 py-1.5 text-xs rounded-lg bg-primary text-primary-foreground hover:bg-primary/90 transition-colors"
          >
            Save
          </button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
